import request from '@/router/axios';

// 获取工单统计数据
export const getWorkorderStats = (days = 7) => {
  return request({
    url: '/api/produce/workorder-stats/stats',
    method: 'get',
    params: { days }
  });
};

// 获取近7天工单统计数据（快捷接口）
export const getWorkorderStatsWeek = () => {
  return request({
    url: '/api/produce/workorder-stats/stats/week',
    method: 'get'
  });
};

// 获取近30天工单统计数据（快捷接口）
export const getWorkorderStatsMonth = () => {
  return request({
    url: '/api/produce/workorder-stats/stats/month',
    method: 'get'
  });
};

// 根据天数查询工单每天的数量统计
export const getDailyCount = (days = 7) => {
  return request({
    url: '/api/produce/workorder-stats/daily/count',
    method: 'get',
    params: { days }
  });
};

// 根据天数查询工单每天的平均处理时长
export const getDailyAvgHours = (days = 7) => {
  return request({
    url: '/api/produce/workorder-stats/daily/avg-hours',
    method: 'get',
    params: { days }
  });
};

// 获取近7天每日工单数量统计（快捷接口）
export const getDailyCountWeek = () => {
  return request({
    url: '/api/produce/workorder-stats/daily/count/week',
    method: 'get'
  });
};

// 获取近7天每日工单平均时长统计（快捷接口）
export const getDailyAvgHoursWeek = () => {
  return request({
    url: '/api/produce/workorder-stats/daily/avg-hours/week',
    method: 'get'
  });
};

// 获取工单汇总统计数据
export const getWorkorderSummary = (days = 7) => {
  return request({
    url: '/api/produce/workorder-stats/summary',
    method: 'get',
    params: { days }
  });
};

// 根据天数查询工单状态分布统计
export const getStatusStats = (days = 7) => {
  return request({
    url: '/api/produce/workorder-stats/status',
    method: 'get',
    params: { days }
  });
};

// 获取近7天工单状态分布统计（快捷接口）
export const getStatusStatsWeek = () => {
  return request({
    url: '/api/produce/workorder-stats/status/week',
    method: 'get'
  });
};
